















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { RelatedModelsGroupViewObject } from '@/types/apiServerContract';

import ReadMore from '@/core/ui-components/ReadMore.vue';
import serverContextService from '@/core/serverContext.service';
import Api from '@/project/http/Api.service';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';

@Component({
    components: { ReadMore, SpinnerOverlay }
})
export default class ProductDetailsRelatedModels extends Vue {
    @Prop({ required: true, type: String })
    private itemId!: string;

    private relatedModelGroups: readonly RelatedModelsGroupViewObject[] = [];
    private relatedModelsLoaded: boolean = false;

    private fetched: string[] = [];
    private loading: string[] = [];

    private hasFetchedFullSection(brandName: string, brandSeries: string) {
        const key = `${brandName}-${brandSeries}`;
        return this.fetched.indexOf(key) >= 0;
    }

    private isLoadingSection(brandName: string, brandSeries: string) {
        const key = `${brandName}-${brandSeries}`;
        return this.loading.indexOf(key) >= 0;
    }

    private get productGuideSpecificGuidePage() {
        return serverContextService?.settings?.productGuideSpecificGuidePage;
    }

    private async getRelatedModels() {
        try {
            const result = await Api.product.relatedModels(this.itemId);
            this.relatedModelGroups = Object.freeze(result.relatedModelGroups);
        } catch {
        } finally {
            this.relatedModelsLoaded = true;
        }
    }

    private async getRelatedModelsSection(brandName: string, brandSeries: string) {
        const key = `${brandName}-${brandSeries}`;
        if (this.fetched.indexOf(key) >= 0) { return; }

        this.loading.push(key);

        try {
            const result = await Api.product.relatedModelsSection(this.itemId, brandName, brandSeries);
            const section = this.relatedModelGroups.find(x => x.brandName === brandName);
            if (section) {
                const models = section.relatedModels.find(x => x.brandSeries === brandSeries);
                if (models) {
                    models.relations = result;
                }
            }

            this.relatedModelGroups = Object.freeze([...this.relatedModelGroups]);
            this.fetched.push(key);
        } finally {
            this.relatedModelsLoaded = true;
            this.loading.splice(this.loading.indexOf(key));
        }
    }

    created() {
        this.getRelatedModels();
    }
}
